export default {
  step1: {
    id: 'new_payment_result_success_step1',
    defaultMessage:
      'We will send you the details of your order by email to the address:',
  },
}
